export default () => {
  const searchHistory = useLocalStorage<string[]>('recentSearches', [])

  const addSearch = (query: string) => {
    if (!query || searchHistory.value.includes(query)) return
    searchHistory.value = [query, ...searchHistory.value.slice(0, 2)]
  }

  const removeSearch = (query: string) => {
    searchHistory.value = searchHistory.value.filter((term) => term !== query)
  }

  return { searchHistory, addSearch, removeSearch }
}
